import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const lunarPhases = {
  New: { name: "New", icon: "🌑" },
  WAXING_CRESCENT: { name: "Waxing crescent", icon: "🌒" },
  FIRST_QUARTER: { name: "First quarter", icon: "🌓" },
  WAXING_GIBBOUS: { name: "Waxing gibbous", icon: "🌔" },
  FULL: { name: "Full", icon: "🌕" },
  WANING_GIBBOUS: { name: "Waning gibbous", icon: "🌖" },
  THIRD_QUARTER: { name: "Third quarter", icon: "🌗" },
  WANING_CRESCENT: { name: "Waning crescent", icon: "🌘" },
}

const getLunarPhase = (age) => {
  if (age < 1.84566) return lunarPhases.New
  else if (age < 5.53699) return lunarPhases.WAXING_CRESCENT
  else if (age < 9.22831) return lunarPhases.FIRST_QUARTER
  else if (age < 12.91963) return lunarPhases.WAXING_GIBBOUS
  else if (age < 16.61096) return lunarPhases.FULL
  else if (age < 20.30228) return lunarPhases.WANING_GIBBOUS
  else if (age < 23.99361) return lunarPhases.THIRD_QUARTER
  else if (age < 27.68493) return lunarPhases.WANING_CRESCENT
  return lunarPhases.New
}

const Container = styled.div`
  display: flex;
  align-items: stretch;
  padding: 0.5rem;
`

const Icon = styled.div`
  flex: none;
  width: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.25rem;
`

const Label = styled.div`
  flex: auto;
  display: flex;
  align-items: center;
  padding: 0 0.5rem;
`

const MoonPhase = ({ moon_phase }) => {
  const phase = getLunarPhase(moon_phase)
  return (
    <Container>
      <Icon>{phase.icon}</Icon>
      <Label>{phase.name}</Label>
    </Container>
  )
}

MoonPhase.propTypes = {
  moon_phase: PropTypes.string, // e.g.  14.1
}

export default MoonPhase
